import type { parseFilterModel } from '@/lib/createAgGridDatasource';
import { buildDownloadOptions, type SortColumnState } from '@/lib/downloadOptions';
import { tauEpitopeKeys } from '@/pages/Study/components/tauSamplesColDefs';
import type { SampleProteoformsDownloadOptions } from '@/services/samples';
import type { ProteoformResultsTableConfig, SampleProteoformFilters } from '@/types';

import { runSampleDetailsSortFields } from './colDefs';

/** Not the study Tau table's allow-lists: those lack flow_cell, lane, well_position and demux_index, so the export would drop them. */
export function buildRunSampleDetailsDownloadOptions(
  columnState: readonly SortColumnState[],
  filterModel: Parameters<typeof parseFilterModel>[0],
  tableConfig: ProteoformResultsTableConfig | undefined,
  thresholdCpm: number,
): SampleProteoformsDownloadOptions {
  const epitopeKeys = tauEpitopeKeys(tableConfig);
  const sortFields = runSampleDetailsSortFields(tableConfig);
  const { sortBy, sortOrder, filters } = buildDownloadOptions<string, SampleProteoformFilters>(
    columnState,
    filterModel,
    sortFields,
    // SampleProteoformFilters' fixed keys are exactly the ProteoformSortFields, so the sort list doubles as the filter list.
    sortFields as (keyof SampleProteoformFilters & string)[],
    // AG Grid serialises set-filter values as strings; the endpoint wants booleans, as the grid's datasource sends.
    new Set(epitopeKeys),
  );
  // Mirrors the grid datasource's fallback; the endpoint's own default is sample_name desc.
  return { filters, sortBy: sortBy ?? 'sample_name', sortOrder: sortBy ? sortOrder : 'asc', thresholdCpm };
}
